import React from "react";
import GearSpinner from '../../components/GearSpinner/GearSpinner';
import './Modal.css';

const ShareMessageModal = ({ isShow, successMessage, errorMessage, onClose }) => {
	return (
		<React.Fragment>
			{isShow && (
				<React.Fragment>
		            <div className="motor-modal-overlay">
		              <div className="motor-modal-content text-center">
		                {(successMessage === '' && errorMessage === '') ? (
		                    <React.Fragment>
		                      <GearSpinner/>
		                    </React.Fragment>
		                  )
		                  :(
		                    <React.Fragment>
		                      {(successMessage !== '') && (
		                        <h6 style={{ color:'green' }}>{successMessage}</h6>
		                      )}
		                      {(errorMessage !== '') && (
		                        <h6 style={{ color:'red' }}>{errorMessage}</h6>
		                      )}
		                    </React.Fragment>
		                  )
		                }
		              </div>
		            </div>
		          </React.Fragment>
			)}
		</React.Fragment>
	)
};

export default ShareMessageModal;